import type { BeaconClient } from '../client.js';

export interface UnknownEmailRow {
  id: string;
  fromEmail: string;
  fromName: string | null;
  subject: string;
  bodyText: string;
  emailMessageId: string | null;
  inReplyTo: string | null;
  references: string[];
  hadAttachments: boolean;
  receivedAt: string;
  status: 'pending' | 'resolved' | 'dismissed';
  resolvedAt: string | null;
  resolvedByUserId: string | null;
  resolutionKind:
    | 'add_domain'
    | 'create_org'
    | 'attach_ticket'
    | 'dismiss'
    | null;
  resolutionTicketId: string | null;
  resolutionOrganizationId: string | null;
}

export interface UnknownEmailListResponse {
  rows: UnknownEmailRow[];
}

export interface UnknownEmailResolveResponse {
  ok: true;
  row: UnknownEmailRow;
  ticketNumber?: string;
  ticketId?: string;
  organizationId?: string;
}

export const unknownEmailsApi = {
  list(
    client: BeaconClient,
    filter: 'pending' | 'all' = 'pending'
  ): Promise<UnknownEmailListResponse> {
    return client.get<UnknownEmailListResponse>(
      `/api/unknown-emails?filter=${encodeURIComponent(filter)}`
    );
  },

  get(client: BeaconClient, id: string): Promise<UnknownEmailRow> {
    return client.get<UnknownEmailRow>(
      `/api/unknown-emails/${encodeURIComponent(id)}`
    );
  },

  addDomain(
    client: BeaconClient,
    id: string,
    organizationId: string
  ): Promise<UnknownEmailResolveResponse> {
    return client.post<UnknownEmailResolveResponse>(
      `/api/unknown-emails/${encodeURIComponent(id)}/add-domain`,
      { organizationId }
    );
  },

  createOrg(
    client: BeaconClient,
    id: string,
    organizationName: string
  ): Promise<UnknownEmailResolveResponse> {
    return client.post<UnknownEmailResolveResponse>(
      `/api/unknown-emails/${encodeURIComponent(id)}/create-org`,
      { organizationName }
    );
  },

  attachTicket(
    client: BeaconClient,
    id: string,
    ticketNumber: string
  ): Promise<UnknownEmailResolveResponse> {
    return client.post<UnknownEmailResolveResponse>(
      `/api/unknown-emails/${encodeURIComponent(id)}/attach-ticket`,
      { ticketNumber }
    );
  },

  dismiss(
    client: BeaconClient,
    id: string
  ): Promise<UnknownEmailResolveResponse> {
    return client.post<UnknownEmailResolveResponse>(
      `/api/unknown-emails/${encodeURIComponent(id)}/dismiss`
    );
  },
};
